import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";
import { LogOut, Users, Inbox, Activity, Zap } from "lucide-react";

export default function OwnerLayout() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/owner/messages");
        if (active) setUnread((data || []).filter(m => !m.read).length);
      } catch (err) { console.error("owner unread load failed:", err); }
    };
    load();
    const id = setInterval(load, 30000);
    return () => { active = false; clearInterval(id); };
  }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-[#fcfbfd]" data-testid="owner-layout">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#fcfbfd]/80 border-b border-[#b182ec]/30">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-8 h-16">
          <div className="flex items-center gap-3">
            <Logo size={40} variant="plain" />
            <div>
              <p className="font-display text-lg font-bold text-[#1a0f2e] leading-none">oRdeN</p>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#7248ae]">Panel Owner</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-[#7248ae]">{user?.email}</span>
            <Button variant="ghost" onClick={logout} className="text-[#3e166c] hover:bg-[#3e166c]/10" data-testid="owner-logout-button">
              <LogOut className="h-4 w-4 mr-2" />Salir
            </Button>
          </div>
        </div>
      </header>

      <nav className="max-w-7xl mx-auto px-4 sm:px-8 mt-6 flex gap-2 flex-wrap">
        <Link to="/owner" data-testid="owner-nav-admins"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${loc.pathname==="/owner" ? "bg-[#3e166c] text-white" : "text-[#3e166c] hover:bg-[#3e166c]/10"}`}>
          <Users className="h-4 w-4" />Administradores
        </Link>
        <Link to="/owner/messages" data-testid="owner-nav-messages"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${loc.pathname.startsWith("/owner/messages") ? "bg-[#3e166c] text-white" : "text-[#3e166c] hover:bg-[#3e166c]/10"}`}>
          <Inbox className="h-4 w-4" />Mensajes
          {unread > 0 && <Badge className="bg-[#e11d48] hover:bg-[#e11d48]/80 ml-1 h-5 px-1.5 text-[10px]" data-testid="messages-unread-badge">{unread}</Badge>}
        </Link>
        <Link to="/owner/health" data-testid="owner-nav-health"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${loc.pathname.startsWith("/owner/health") ? "bg-[#3e166c] text-white" : "text-[#3e166c] hover:bg-[#3e166c]/10"}`}>
          <Activity className="h-4 w-4" />Salud de cuentas
        </Link>
        <Link to="/owner/churn" data-testid="owner-nav-churn"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${loc.pathname.startsWith("/owner/churn") ? "bg-[#3e166c] text-white" : "text-[#3e166c] hover:bg-[#3e166c]/10"}`}>
          <Zap className="h-4 w-4" />Score de churn
        </Link>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
